export const CONTACT_US_LIST_REQUEST = "CONTACT_US_LIST_REQUEST";
export const CONTACT_US_LIST_RECEIVE = "CONTACT_US_LIST_RECEIVE";
export const CONTACT_US_LIST_FAILURE = "CONTACT_US_LIST_FAILURE";
export const RESET_CONTACT_US_LIST = "RESET_CONTACT_US_LIST";

export const CONTACT_US_BUTTON_REQUEST = "CONTACT_US_BUTTON_REQUEST";
export const CONTACT_US_BUTTON_RECEIVE = "CONTACT_US_BUTTON_RECEIVE";
export const CONTACT_US_BUTTON_FAILURE = "CONTACT_US_BUTTON_FAILURE";
export const RESET_CONTACT_US_BUTTON = "RESET_CONTACT_US_BUTTON";
